<template>
  <div class="illustration-choice">
        <p>イラストを選択してください</p>
        <img v-bind:src="avatar.img" v-bind:class="[active === 0 ? 'active-bg' : '']"
        @click="selectIllust(); active = 0;"/>
      </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const AvatarRepository = RepositoryFactory.get("avatar");
export default {
  data () {
    return {
      illust: Number,
      active: "",
      avatar: {
        id: "",
        img: ""
      }
    }
  },
  async mounted() {
    const firstItem = 0
    const healthDevStorage = "https://healthdevstorage.blob.core.windows.net/health/"
    const gender = this.$store.state.users.gender
    await AvatarRepository.get(gender, this.$store.state.axiosHeaders).then((response) => {
      this.avatar.id = response.data[firstItem].id
      this.avatar.img = healthDevStorage + response.data[firstItem].avatar_img_path[firstItem]
    })
    .catch((error) => console.log(error));
  },
  methods: {
    selectIllust() {
      this.$emit("handle-change-avatar-id", this.avatar.id)
    }
  }
}

</script>

<style scoped>
.illustration-choice {
  margin-top: 5vh;
}
.illustration-choice p {
  font-size: 1.2rem;
  font-weight: bold;
}
.illustration-choice img {
  border: solid 1px gainsboro;
    border-radius: 10px;
    width: 25%;
    padding: 5% 7%;
}
.active-bg {
  background-color: #00a0b9;
}
</style>



// WEBPACK FOOTER //
// src/templates/SelectIllustrationPage.vue